
<div class="container-fluid">
  <page-header-search
    [isSearchInput]="true"
    pageTitleValue="Search"
    placeholderValue="Patient Name or Mobile Number or National ID or Passport ID"
    (onHeaderSearchSubmit)="onSearchPatients($event)"
  ></page-header-search>

  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-12">
          <div class="d-flex justify-content-between align-items-center" style="gap: 25px;">
            <h3 class="m-0">Patients</h3>
            <button class="btn btn-neutral" (click)="exportToExcel()">
              <span class="btn-inner--icon">
                <i class="ni ni-cloud-download-95"> </i>
              </span>
              <span class="btn-inner--text"> Download as Excel </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <ngx-datatable class="material ngx-datatable-custom" [rows]="patientList"
      [columns]="columns" [limit]="searchParams.pageSize" [offset]="searchParams.currentPage-1"
      columnMode="force" externalPaging="true" [count]="totalItems" [scrollbarH]="true"
      [headerHeight]="50" [footerHeight]="50" rowHeight="auto" (page)="onChangePage($event)"
      selectionType="single" (select)="routeToPatientDetails($event)" [messages]="messages">
      <ng-template let-row="row" #nationalIdPassportIdRef ngx-datatable-row-detail-template>
        <span class="ng-star-inserted">{{row.nationalId}} {{row.nationalId && row.passportId && ' / '}} {{row.passportId}}</span>
      </ng-template>
    </ngx-datatable>
  </div>
</div>
<ngx-spinner></ngx-spinner>
